import client from "../../../vendor/rshop/frontend/assets/js/common/client";

const $ = window.jQuery;

export function initQuestionForm() {
    $(".js-product-question-form").validate({
        submitHandler: function (form) {
            $(form).find('[type="submit"]').addClass("is-loading");

            window.Form.ajaxPost(
                form,
                function (data) {
                    const message = $(".js-product-question-message");
                    message.slideUp(100);

                    if (data.status) {
                        $(".js-product-question-form").slideUp();
                    }

                    message
                        .toggleClass("c-msg--error", !data.status)
                        .toggleClass("c-msg--success", data.status)
                        .text(data.message)
                        .slideDown();

                    rEvent.dispatch("Recaptcha.execute");

                    $(form).find('[type="submit"]').removeClass("is-loading");
                },
                "json"
            );
        },
    });
}
